$$('#guideMain li i').addEvent('click', function () {
   this.classList.toggle('expanded');
});
